import { render, staticRenderFns } from "./GerenciarAdministradores.vue?vue&type=template&id=586dcde9&scoped=true&"
import script from "./GerenciarAdministradores.vue?vue&type=script&lang=js&"
export * from "./GerenciarAdministradores.vue?vue&type=script&lang=js&"
import style0 from "./GerenciarAdministradores.vue?vue&type=style&index=0&id=586dcde9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586dcde9",
  null
  
)

export default component.exports